import { create } from 'zustand';

interface ILayoutStore {
	layout: {
		compact: boolean;
		smallLayout: boolean,
		showLeftMenu: boolean;
	};
	setLayout: (isLarge: boolean) => void;
	setShowLeftMenu: (isLarge: boolean) => void;
	setCompact: (value: boolean) => void;
}

export const layoutStore = create<ILayoutStore>(set => ({
	layout: {
		compact: false,
		smallLayout: false,
		showLeftMenu: false,
	},
	setLayout: isLarge => set(state => ({
		layout: {
			...state.layout,
			smallLayout: isLarge,
			compact: false,
		},
	})),
	setShowLeftMenu: isLarge => set(state => ({
		layout: {
			...state.layout,
			showLeftMenu: isLarge,
		},
	})),
	setCompact: value => set(state => ({
		layout: {
			...state.layout,
			compact: value,
		},
	})),
}));
